<template>
  <div class="error contents">
    <div class="errorCnts">
      <div class="errorForm">
        <p v-html="$t('error.error_message_G07')"></p>
        <div class="bt">
          <button type="button" class="button13">
            {{ $t('error.button') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage'
}
</script>

<style lang="scss" scoped>
.error {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: none;
  height: 100%;
  background-color: #e9eaf1;
  z-index: 10;
  .errorCnts {
    width: 100%;
    display: table;
    height: 100%;
  }
  .errorForm {
    display: table-cell;
    vertical-align: middle;
    padding: 0 20px;
  }
  p {
    position: relative;
    width: 100%;
    max-width: 600px;
    min-height: 77px;
    padding: 19px 16px 16px;
    margin: 84px auto 0;
    color: #50535f;
    text-align: center;
    font-size: 13px;
    line-height: 20px;
    border: 1px solid #e1e3f0;
    background-color: #fff;
    &::before {
      content: '';
      position: absolute;
      top: -84px;
      left: 0;
      display: block;
      width: 100%;
      height: 37px;
      margin-top: 32px;
      margin-bottom: 13px;
      background: url(../../assets/images/set_none.png) no-repeat center -150px;
      background-size: 50px;
    }
  }
  .bt {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 0 20px 20px;
    text-align: center;
    button {
      max-width: 600px;
      border-radius: 4px;
    }
  }
}
</style>
